export const environment = {
    production: false,
    name: 'HOM',
    API_URL: 'https://apigateway-hom.procempa.com.br/apiman-gateway/ambiental-urbanismo/reurb/1.0',
    KEYCLOAK_URL: 'https://sso-pmpa-hom.procempa.com.br/auth',
    KEYCLOAK_REALM: 'pmpa',
    KEYCLOAK_CLIENT: 'reurb'
};
